import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import strings from 'owa-strings/owa-mail-strings';
import { ComposeActionKey, ReadActionKey, HoverActionKey } from 'owa-outlook-service-options';
import { format } from 'owa-strings';

export const DIVIDER_DISPLAY_NAME = '-';

export function getComposeActionDisplayName(key: ComposeActionKey): string {
    switch (key) {
        case 'AddAttachment':
            return strings.attachTooltip;
        case 'AddInlineImage':
            return strings.insertPicturesInlineTooltip;
        case 'AddEmoji':
            return strings.emojiTooltip;
        case 'ToggleRibbon':
            return strings.formattingOptionsTooltip;
        case 'SaveDraft':
            return strings.saveDraft;
        case 'InsertSignature':
            return strings.insertSignature;
        case 'ShowFrom':
            return strings.showFrom;
        case 'SetImportance':
            return strings.setImportance;
        case 'ShowMessageOptions':
            return strings.showMessageOptions;
        case 'SwitchBodyType':
            return strings.switchToPlainTextMenuItem;
        case 'ProtectMessage':
            return strings.composeProtectButton;
        case 'AccChecker':
            return strings.accCheckerMenuItemText;
        default:
            return '';
    }
}

export function getReadActionDisplayName(key: ReadActionKey): string {
    switch (key) {
        case 'LikeUnlike':
            return strings.itemHeaderLike;
        case 'Reply':
            return strings.itemHeaderReply;
        case 'ReplyAll':
            return strings.itemHeaderReplyAll;
        case 'Forward':
            return strings.itemHeaderForward;
        case 'ReplyByMeeting':
            return strings.itemHeaderReplyByMeeting;
        case 'ReportAbuse':
            return strings.reportAbuse;
        case 'Popout':
            return strings.popoutsOpenInNewWindow;
        case 'Delete':
            return strings.itemHeaderDelete;
        case 'MarkReadUnread':
            return strings.markAsUnread;
        case 'FlagUnflag':
            return strings.itemHeaderFlag;
        case 'AssignPolicy':
            return strings.assignPolicyMenuItemName;
        case 'AddToSafeSenders':
            return strings.itemHeaderAddToSafeSenders;
        case 'MarkJunkNotJunk':
            return strings.itemHeaderMarkAsJunk;
        case 'MarkAsPhishing':
            return strings.itemHeaderMarkAsPhishing;
        case 'Block':
            return format(strings.itemHeaderBlock, '');
        case 'CreateRule':
            return strings.createRule;
        case 'Print':
            return strings.itemHeaderPrint;
        case 'Translate':
            return strings.itemHeaderTranslate;
        case 'ShowInImmersiveReader':
            return strings.showInImmersiveReader;
        case 'ViewMessageSource':
            return isConsumer()
                ? strings.itemHeaderViewMessageSource
                : strings.itemHeaderViewMessageDetails;
        case 'ToggleDarkMode':
            return strings.itemHeaderLightsOn;
        default:
            return '';
    }
}

export function getHoverActionDisplayName(key: HoverActionKey): string {
    switch (key) {
        case 'None':
            return strings.none;
        case 'Delete':
            return strings.deleteItem;
        case 'Archive':
            return strings.archive;
        case 'PinUnpin':
            return strings.pin;
        case 'ReadUnread':
            return strings.readUnread;
        case 'FlagUnflag':
            return strings.flag;
        case 'Move':
            return strings.moveToFolder;
        default:
            return '';
    }
}
